<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path fill-rule="evenodd" d="M8.5 6A1.5 1.5 0 0110 4.5h18a1.5 1.5 0 011.06.44l10 10A1.5 1.5 0 0139.5 16v26a1.5 1.5 0 01-1.5 1.5H10A1.5 1.5 0 018.5 42V6zm3 1.5v33h25v-23H28a1.5 1.5 0 01-1.5-1.5V7.5h-15zm18 2.121l4.879 4.879H29.5V9.621zM18 32.5a1.5 1.5 0 000 3h12a1.5 1.5 0 000-3H18zM16.5 26a1.5 1.5 0 011.5-1.5h12a1.5 1.5 0 010 3H18a1.5 1.5 0 01-1.5-1.5zm1.5-9.5a1.5 1.5 0 000 3h4a1.5 1.5 0 000-3h-4z"/></svg>